export default "__VITE_ASSET__BWVkn3Ra__"